import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'reactstrap';
import './styles.scss';

const tableWidget = props => {
  const { thead, tbody } = props;

  return (
    <div className="table-responsive">
      <Table className="table table-padded">
        <thead className="">
          <tr>
            {thead.map((prop, key) => {
              if (key === thead.length - 1)
                return (
                  <th key={key} className="text-right">
                    {prop}
                  </th>
                );
              return <th key={key}>{prop}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {tbody.map((prop, key) => (
            <tr key={key}>
              {prop.data.map((prop, key) => {
                if (key === thead.length - 1) return <td key={key}>{prop}</td>;
                return <td key={key}>{prop}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

tableWidget.propTypes = {
  thead: PropTypes.array.isRequired,
  tbody: PropTypes.array.isRequired,
};

export default tableWidget;
